module.exports = __webpack_public_path__ + "img/img_kit.2099b760.png";